import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import SimpleCountrySelect from "../../../components/dashboard/common/form/SimpleCountrySelect";
import SimpleInput from "../../../components/dashboard/common/form/SimpleInput";
import SimpleSelect from "../../../components/dashboard/common/form/SimpleSelect";
import GallerySlot from "../../../components/dashboard/user-dashboard/GallerySlot";
import ImageUpload from "../../../components/dashboard/user-dashboard/ImageUpload";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import { years } from "../../../functions/YearGenerate";
import { uploadToS3 } from "../../../functions/uploadToS3";
import { countWords, MAX_WORD_LIMIT } from "../../../functions/wordCount";
import { filters } from "../../../mock/DropdownOptions";
import { uploadProject } from "../../../service/DashboardService";


const phaseOptions =
  filters.find((filter) => filter.id === "phase" && filter.name === "Phase")
    ?.options || [];

const materialOptions =
  filters.find(
    (filter) => filter.id === "material" && filter.name === "Materials"
  )?.options || [];

const typologyOptions =
  filters.find(
    (filter) => filter.id === "typologySubCategory" && filter.name === "Typology"
  )?.options || [];

const colorOptions =
  filters.find((filter) => filter.id === "colors" && filter.name === "Colors")
    ?.options || [];

const styleOptions =
  filters.find(
    (filter) =>
      filter.id === "style" && filter.name === "Architecture Style"
  )?.options || [];

const modelingOptions =
  filters.find(
    (filter) =>
      filter.id === "modeling" && filter.name === "Modeling"
  )?.options || [];

const renderingOptions =
  filters.find(
    (filter) =>
      filter.id === "rendering" && filter.name === "Rendering"
  )?.options || [];

const AddNewProject = () => {
  const [projectData, setProjectData] = useState({
    ProjectName: "",
    ProjectDescription: "",
    Concept: "",
    Innovation: "",
    Area: 0,
    Years: 0,
    Phase: "",
    Style: "",
    Materials: "",
    TypologyCategory: "",
    TypologySubCategory: "",
    Colors: "",
    ImageUrls: [],
    Country: {},
    Modeling: "",
    Rendering: "",
    Architecture: "",
    Image1: "",
    Image2: "",
    Image3: "",
    Image4: "",
    Image5: ""

  });
  const [typologySubcategoryOptions, setTypologySubcategoryOptions] = useState([]);
  const [selectedTypology, setSelectedTypology] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadingSlot, setUploadingSlot] = useState(null);
  const [descriptionWordCount, setDescriptionWordCount] = useState(0);
  const descriptionExceeded = descriptionWordCount > MAX_WORD_LIMIT;

  const MAX_GALLERY_IMAGES = 15;

  const handleDescriptionChange = (e) => {
    const text = e.target.value;
    const wc = countWords(text);
    setDescriptionWordCount(wc);
    if (wc > MAX_WORD_LIMIT) {
      toast.warning(`Project description cannot exceed ${MAX_WORD_LIMIT} words. Current: ${wc}`, { toastId: "word-limit-warning" });
    }
    setProjectData({ ...projectData, ProjectDescription: text });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (descriptionExceeded) {
      toast.error(`Please reduce the description to ${MAX_WORD_LIMIT} words or fewer before submitting.`);
      return;
    }
    try {

      const token = localStorage.getItem("accessToken");
      const name = localStorage.getItem("name");
      const userId = parseInt(localStorage.getItem("userId"), 10);
      const countryId = parseInt(projectData.Country.countryId, 10);
      const area = parseInt(projectData.Area, 10);
      const year = parseInt(projectData.Years, 10);

      const response = await uploadProject(projectData, userId, token, countryId, area, year, name);

      if (response) {
        setProjectData({
          ProjectName: "",
          ProjectDescription: "",
          Concept: "",
          Innovation: "",
          Area: 0,
          Years: 0,
          Phase: "",
          Style: "",
          Materials: "",
          Collaborators: "",
          TypologyCategory: "",
          TypologySubCategory: "",
          Colors: "",
          MainImage: null,
          ImageUrls: [],
          Country: {},
          Modeling: "",
          Rendering: "",

        });
        setLoading(false);
        toast.success("Project Uploaded successfully");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Something went wrong");
    }
  };


  const handleSingleImageUpload = async (event, slotIndex) => {
    const file = event.currentTarget.files[0];
    if (!file) return;

    // Reset the input so the same file can be re-selected
    event.currentTarget.value = '';

    setUploading(true);
    setUploadingSlot(slotIndex);
    try {
      const url = await uploadToS3(file, () => { }, "ImageUrls");
      if (url) {
        setProjectData((prev) => {
          const currentUrls = prev.ImageUrls || [];
          if (currentUrls.length >= MAX_GALLERY_IMAGES) {
            toast.warning(`Maximum ${MAX_GALLERY_IMAGES} images allowed`);
            return prev;
          }
          return { ...prev, ImageUrls: [...currentUrls, url] };
        });
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      toast.error("Failed to upload image");
    } finally {
      setUploading(false);
      setUploadingSlot(null);
    }
  };

  const handleMainImageUpload1 = async (event) => {
     const file = event.currentTarget.files[0];
     setProjectData((prev) => ({ ...prev, Image1: file }));
     await uploadToS3(file, setProjectData, "Image1");
   };
   const handleMainImageUpload2 = async (event) => {
     const file = event.currentTarget.files[0];
     setProjectData((prev) => ({ ...prev, Image2: file }));
     await uploadToS3(file, setProjectData, "Image2");
   };
   const handleMainImageUpload3 = async (event) => {
     const file = event.currentTarget.files[0];
     setProjectData((prev) => ({ ...prev, Image3: file }));
     await uploadToS3(file, setProjectData, "Image3");
   };
   const handleMainImageUpload4 = async (event) => {
     const file = event.currentTarget.files[0];
     setProjectData((prev) => ({ ...prev, Image4: file }));
     await uploadToS3(file, setProjectData, "Image4");
   };
   const handleMainImageUpload5 = async (event) => {
     const file = event.currentTarget.files[0];
     setProjectData((prev) => ({ ...prev, Image5: file }));
     await uploadToS3(file, setProjectData, "Image5");
   };



  useEffect(() => {
    const selectedTypologyOptions = typologyOptions.find(
      (option) => option.value === selectedTypology
    );

    if (selectedTypologyOptions) {
      setTypologySubcategoryOptions(
        selectedTypologyOptions.subcategories || []
      );
    } else {
      setTypologySubcategoryOptions([]);
    }
  }, [selectedTypology]);

  const handleTypologyChange = (event) => {
    setSelectedTypology(event.target.value);
    setProjectData({
      ...projectData,
      TypologyCategory: event.target.value,
    });
  };

  const handleDeleteImage = (index) => {
    setProjectData((prev) => {
      const newImageUrls = [...(prev.ImageUrls || [])];
      newImageUrls.splice(index, 1);
      return { ...prev, ImageUrls: newImageUrls };
    });
  };

  return (
    <div>
      <TopHeader tabName={"Upload new Project"} />
      <form onSubmit={handleSubmit}>
        <div className="">
          <div className=" pb-12">
            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="sm:col-span-2">
                <SimpleInput
                  type={"text"}
                  label={"Project Name"}
                  value={projectData.ProjectName}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      ProjectName: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-span-full">
                <SimpleInput
                  type={"text"}
                  label={"Project Description"}
                  value={projectData.ProjectDescription}
                  onChange={handleDescriptionChange}
                  inputType={"textarea"}
                  rows={3}
                  required
                />
                <div className={`mt-1 text-sm flex justify-between ${descriptionExceeded ? 'text-red-600 font-semibold' : 'text-gray-500'}`}>
                  <span>
                    {descriptionExceeded
                      ? `⚠ Word limit exceeded! Please reduce to ${MAX_WORD_LIMIT} words.`
                      : `${descriptionWordCount} / ${MAX_WORD_LIMIT} words`
                    }
                  </span>
                  <span>{descriptionWordCount} / {MAX_WORD_LIMIT}</span>
                </div>
              </div>
              <div className="col-span-3">
                <SimpleInput
                  type={"text"}
                  label={"Concept"}
                  value={projectData.Concept}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      Concept: e.target.value,
                    })
                  }
                  inputType={"textarea"}
                  rows={3}
                  required
                />
              </div>
              <div className="col-span-3">
                <SimpleInput
                  type={"text"}
                  label={"Innovation"}
                  value={projectData.Innovation}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      Innovation: e.target.value,
                    })
                  }
                  inputType={"textarea"}
                  rows={3}
                  required
                />
              </div>
            </div>
          </div>

          <div className="border-b border-gray-900/10 pb-12">
            <div className=" grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="sm:col-span-2 sm:col-start-1">
                <SimpleInput
                  type="number"
                  label={"Area"}
                  value={projectData.Area}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      Area: e.target.value,
                    })
                  }
                  required
                />
              </div>

              <div className="sm:col-span-2">
                <SimpleSelect
                  type={"nubertext"}
                  title={"Year"}
                  selectoptions={years}
                  value={projectData.Years}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      Years: e.target.value,
                    })
                  }
                  required
                />
              </div>

              <div className="sm:col-span-2">
                <SimpleCountrySelect
                  value={projectData?.Country?.countryId}
                  onChange={(e) => {
                    console.log(e.target.value);
                    setProjectData({
                      ...projectData,
                      Country: { countryId: e.target.value },
                    });
                  }}
                  required
                />

              </div>

              <div className="sm:col-span-2">
                <SimpleSelect
                  type={"text"}
                  title={"Typology Category"}
                  selectoptions={typologyOptions}
                  value={selectedTypology}
                  onChange={handleTypologyChange}
                  required
                />

              </div>

              <div className="sm:col-span-2">
                <SimpleSelect
                  type={"text"}
                  title={"Typology SubCategory"}
                  selectoptions={typologySubcategoryOptions}
                  value={projectData.TypologySubCategory}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      TypologySubCategory: e.target.value,
                    })
                  }
                  required
                  disabled={!selectedTypology}
                />
              </div>



              <div className="sm:col-span-2">
                <SimpleSelect
                  type={"text"}
                  title={"Phase"}
                  selectoptions={phaseOptions}
                  value={projectData.Phase}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      Phase: e.target.value,
                    })
                  }

                />
              </div>

              <div className="sm:col-span-2">
                <SimpleSelect
                  type={"text"}
                  title={"Architecture Style"}
                  selectoptions={styleOptions}
                  value={projectData.Style}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      Style: e.target.value,
                    })
                  }

                />
              </div>

              <div className="sm:col-span-2">
                <SimpleSelect
                  type={"text"}
                  title={"Materials"}
                  selectoptions={materialOptions}
                  value={projectData.Materials}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      Materials: e.target.value,
                    })
                  }

                />
              </div>

              <div className="sm:col-span-2">
                <SimpleSelect
                  type={"text"}
                  title={"Colors"}
                  selectoptions={colorOptions}
                  value={projectData.Colors}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      Colors: e.target.value,
                    })
                  }

                />
              </div>
              <div className="sm:col-span-2">
                <SimpleSelect
                  type={"text"}
                  title={"Modeling Software"}
                  selectoptions={modelingOptions}
                  value={projectData.Modeling}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      Modeling: e.target.value,
                    })
                  }

                />
              </div>
              <div className="sm:col-span-2">
                <SimpleSelect
                  type={"text"}
                  title={"Rendering Software"}
                  selectoptions={renderingOptions}
                  value={projectData.Rendering}
                  onChange={(e) =>
                    setProjectData({
                      ...projectData,
                      Rendering: e.target.value,
                    })
                  }

                />
              </div>
              <div className="sm:col-span-2">

              </div>
              <div className="sm:col-span-2">
                <ImageUpload title={"Main Image"} handleFloorImagesUpload={handleMainImageUpload1} previewUrl={projectData.Image1} />
              </div>
              <div className="sm:col-span-2">
                <ImageUpload title={"Floor Plans"} handleFloorImagesUpload={handleMainImageUpload2} previewUrl={projectData.Image2} />
              </div>
              <div className="sm:col-span-2">
                <ImageUpload title={"Floor Plans/ Building Section"} handleFloorImagesUpload={handleMainImageUpload3} previewUrl={projectData.Image3} />
              </div>
              <div className="sm:col-span-2">
                <ImageUpload title={"Floor Plans/ Details Callout"} handleFloorImagesUpload={handleMainImageUpload4} previewUrl={projectData.Image4} />
              </div>
              <div className="sm:col-span-2">
                <ImageUpload title={"Floor Plans/ Support"} handleFloorImagesUpload={handleMainImageUpload5} previewUrl={projectData.Image5} />
              </div>
              <div className="sm:col-span-full">
                <h3 className="text-sm font-medium text-gray-700 mb-2">
                  Gallery Images (Optional) ({(projectData.ImageUrls || []).filter(url => !!url).length} / {MAX_GALLERY_IMAGES})
                </h3>
                <div className="mt-2 grid grid-cols-5 gap-3">
                  {[...Array(MAX_GALLERY_IMAGES)].map((_, index) => {
                    const currentImages = (projectData.ImageUrls || []).filter(url => !!url);
                    return (
                      <GallerySlot
                        key={index}
                        index={index}
                        imageUrl={currentImages[index] || null}
                        uploading={uploading}
                        uploadingSlot={uploadingSlot}
                        onUpload={handleSingleImageUpload}
                        onDelete={handleDeleteImage}
                      />
                    );
                  })}
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 flex items-center justify-end gap-x-6">
          <button
            type="button"
            className="text-sm font-semibold leading-6 text-gray-900"
          >
            Reset
          </button>
          <button
            type="submit"
            disabled={descriptionExceeded}
            className={`flex items-center gap-2 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 focus:ring-4 focus:outline-none ${
              descriptionExceeded
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'text-gray-900 bg-gradient-to-r from-cyan-200 via-cyan-300 to-cyan-400 hover:bg-gradient-to-br focus:ring-cyan-300 dark:focus:ring-cyan-800'
            }`}
          >
            {loading ? "processing" : "Add Project"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddNewProject;
